import StepCallout from './step-callout';

import { Stack } from 'ui/stack';
import { Box } from 'ui/box';

const CALLOUT_STEPS = [
  {
    label: 'Start broad',
    prompt: '“What is the biggest YoY change in my 2026 deposit pool?”',
  },
  {
    label: 'Add a filter',
    prompt:
      '“Where geographically is our largest YoY decline in deposit volume?”',
  },
  {
    label: 'Drill deeper',
    prompt: '“Break that down by income band.”',
  },
  {
    label: 'Turn insight into action',
    prompt: '“Which regions should we prioritize for travel this fall?”',
  },
];

const MarkWalkthroughStep2 = () => (
  <Stack sx={{ flex: '1 1 0%', gap: 2, pt: 2 }}>
    <Box>
      <h2 className="text-xl font-bold text-gray-900">
        Dig deeper — one question leads to the next.
      </h2>
      <p className="mt-1 text-base text-gray-700">
        MARK holds the thread of your conversation. Each follow-up builds on the
        last — no need to repeat context or start over.
      </p>
    </Box>

    <StepCallout steps={CALLOUT_STEPS} />

    <p className="text-base text-gray-700">
      Start broad, then narrow down to the insight that matters. Each answer
      opens the door to the next question.
    </p>
  </Stack>
);

export default MarkWalkthroughStep2;
